$(function () {
    navigationToggler();
});

function navigationToggler() {
    if ($(window).width() < 992) {
        $('.nav-title').on('click', function () {
            var $accordionContent = $('.woocommerce-MyAccount-navigation');

            $accordionContent.slideToggle();
            $(this).toggleClass('opened');
        });
    }
}